import React from "react";
import PropTypes from "prop-types";
import Alert from "shared/components/utils/icons/Alert";
import { Container, InputError, TextArea } from "./TextAreaInput.styles";

const TextAreaInput = React.forwardRef((props, ref) => {
    const { label, value } = props;

    function handleChange(e) {
        props.onChange(e);
    }

    return (
        <Container>
            <TextArea
                value={value}
                onChange={handleChange}
                error={!!(props.className && props.className.includes("error") > 0)}
                disabled={props.disabled}
                placeholder={label}
                ref={ref}
            />
            {props.className?.includes("error") && (
                <InputError>
                    <Alert />
                </InputError>
            )}
        </Container>
    );
});

TextAreaInput.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

export default TextAreaInput;
